import Dexie from 'dexie';

const db = new Dexie('carcheck.answers');
db.version(1).stores({ answers: 'id, formId, status' });

export default db;
